import React from 'react';
import './loader.css';

export const Loader = () => {
  return <span className='loader' />;
};
